import { Store } from 'src/store/index';

const areAllFormatsLoading = (store: Store) => store.format.allFormatsAreLoading;

export default areAllFormatsLoading;
